import { jsx as _jsx } from "react/jsx-runtime";
import { reportErrorToBugsnag } from "@air/utils-error";
import { useRouter } from "next/router";
import { createContext, useContext, useMemo, useRef } from "react";
import isEqual from "react-fast-compare";
import { useAccountContext } from "~/providers/AccountProvider";
import { FiltersModifiedManuallyProvider } from "~/providers/FiltersModifiedManuallyProvider";
import { isDevOrTestStage } from "~/swr-hooks/utils";
import { urlQueryToFilterParams } from "~/utils/filters/urlQueryToFilterParams";
const defaultValue = {
    filters: {},
    immutableFilters: {},
    accountId: undefined,
    search: undefined
};
const FiltersContext = /*#__PURE__*/ createContext(defaultValue);
export const FiltersProvider = (param)=>{
    let { children, getImmutableFilters } = param;
    const { data: account } = useAccountContext();
    const { asPath } = useRouter();
    const filtersValue = useRef({
        ...defaultValue
    });
    filtersValue.current = useMemo(()=>{
        const searchParams = "object" !== "undefined" ? window.location.search : "";
        /**
     * We do not use query from useRouter, because it contains also boardId, clipId, libraryId etc. - all params from url, not just search params
     */ const query = new URLSearchParams(searchParams);
        const filters = urlQueryToFilterParams({
            query
        });
        var _getImmutableFilters;
        const immutableFilters = (_getImmutableFilters = getImmutableFilters === null || getImmutableFilters === void 0 ? void 0 : getImmutableFilters({
            asPath,
            accountId: account === null || account === void 0 ? void 0 : account.id,
            userFilters: filters
        })) !== null && _getImmutableFilters !== void 0 ? _getImmutableFilters : {};
        const newFilters = {
            ...filters,
            immutableFilters,
            accountId: account === null || account === void 0 ? void 0 : account.id
        };
        if (isEqual(filtersValue.current, newFilters)) {
            return filtersValue.current;
        } else {
            return newFilters;
        }
    }, [
        account === null || account === void 0 ? void 0 : account.id,
        asPath,
        getImmutableFilters
    ]);
    return /*#__PURE__*/ _jsx(FiltersContext.Provider, {
        value: filtersValue.current,
        children: /*#__PURE__*/ _jsx(FiltersModifiedManuallyProvider, {
            children: children
        })
    });
};
export const useFiltersContext = ()=>{
    const context = useContext(FiltersContext);
    if (context === defaultValue) {
        const error = "FiltersContext used outside of FiltersProvider";
        if (isDevOrTestStage()) {
            throw error;
        } else {
            reportErrorToBugsnag({
                error,
                context: error
            });
        }
    }
    return context;
};
